import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { BiCheck } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { IconType } from "react-icons/lib";
import { NullableCheckboxState } from "./types";

const checkboxStates = {
  Checked: true,
  NotChecked: false,
  Empty: null
};

interface NullableCheckboxProps {
  initialValue: NullableCheckboxState;
  onChange: (newState: NullableCheckboxState) => void;
}

const NullableCheckbox: React.FC<NullableCheckboxProps> = ({ initialValue, onChange }) => {
  const [color, setColor] = useState("gray.700");
  const [icon, setIcon] = useState<IconType | null>();
  const [isChecked, setIsChecked] = useState<NullableCheckboxState>(initialValue);

  const nextState = (): NullableCheckboxState => {
    switch (isChecked) {
      case checkboxStates.Checked:
        return checkboxStates.NotChecked;
      case checkboxStates.NotChecked:
        return checkboxStates.Empty;
      case checkboxStates.Empty:
        return checkboxStates.Checked;
      default:
        return checkboxStates.Empty;
    }
  }

  const changeCheckbox = (newState: NullableCheckboxState) => {
    setIsChecked(newState)
    switch (newState) {
      case checkboxStates.Checked:
        setColor("blue.500");
        setIcon(BiCheck);
        break;
      case checkboxStates.NotChecked:
        setColor("red.500");
        setIcon(IoClose)
        break;
      case checkboxStates.Empty:
        setColor("gray.700");
        setIcon(null);
        break;
    }
  }

  useEffect(() => {
    changeCheckbox(initialValue);
  }, [initialValue]);

  return (
    <Box>
      <Box
        margin="5px"
        backgroundColor={color}
        onClick={() => {
          const newState: NullableCheckboxState = nextState();
          changeCheckbox(newState);
          onChange(newState);
        }}
        borderWidth="2px"
        borderRadius="2px"
        h="17px"
        w="17px"
        cursor="pointer"
        display="inline-flex"
        verticalAlign="top"
        position="relative"
      >
        {icon}
      </Box>
    </Box>
  )
};

export default NullableCheckbox;
